import { useState, useEffect } from 'react';
import { headerNav } from '@/mocks/homeData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-[72px] px-4 md:px-6">
        <a href="#hero" className="flex items-center gap-2 no-underline">
          <span className="text-xl md:text-2xl font-heading font-bold text-accent-600 whitespace-nowrap">
            吃瓜网每日大赛
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {headerNav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(item.href);
              }}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-accent-600 rounded-lg hover:bg-accent-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button className="px-5 py-2 text-sm font-medium bg-accent-500 text-white rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer">
            下载APP
          </button>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-2">
          {headerNav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(item.href);
              }}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-accent-600 hover:bg-accent-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
          <button className="mt-2 px-5 py-3 text-sm font-medium bg-accent-500 text-white rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer">
            下载APP
          </button>
        </div>
      )}
    </header>
  );
}